import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import store from "../../index";
import { toast } from "react-toastify";
const initialState = {
  loginData: {},
  Status: "N",
  msg: "",
  loading: false,
  error: "",

  dashBoardTaskGetData: [],
  dashBoardTaskGetStaus: "idle",
  dashBoardTaskGetLoading: false,
  dashBoardTaskGetError: null,
  ScoredashBoardGetData: {
    ScoreChart: {
      xaxis: [],
      yaxis: [],
      details: [],
    },
  },

  dashBoardAttenGetData: {
    taskSummaryCardData: [],
    taskWeekMonthData: {
      weekData: [],
      monthData: [],
      xaxis: [],
      yaxis: [],
    },
    projectTaskData: {
      xaxis: [],
      yaxis: [],
      leaveDetailsData: {
        tableData: [],
      },
      CumulativeChart: {
        xaxis: [],
        yaxis: [],
      },
    },
    leaveDetailsData: {
      tableData: [],
      others: [],
      currentMonth: [],
      nextMonth: [],
      currentYear: [],
    },
    agingData: {
      backlogData: [],
      todoData: [],
      completedData: [],
    },
    attendanceOverViewData: {
      laybels: [],
      Yearlysereies: [],
      Monthlysereies: [],
    },
    CumulativeChart: {
      xaxis: [],
      yaxis: [],
    },
  },

  //separate dash_V2
  //status
  loadingV2: false,
  errorV2: null,

  //full dashboard data
  dashboardDataV2: {
    taskSummaryCardData: [],

    taskTimeline: {
      w2d: [],
      m2d: [],
    },

    tasks: {
      w2d: {
        backlog: [],
        todo: [],
        inprogress: [],
        completed: [],
        approved: [],
      },
      m2d: {
        backlog: [],
        todo: [],
        inprogress: [],
        completed: [],
        approved: [],
      },
    },

    projectStats: [],

    projectTaskData: {
      xaxis: [],
      Projects: [],
      yaxis: [],
    },

    taskAging: {
      backlog: { labels: [], data: [], colors: [] },
      todo: { labels: [], data: [], colors: [] },
      completed: { labels: [], data: [], colors: [] },
    },

    attendance: {
      Y2D: { labels: [], data: [], colors: [] },
      W2D: { labels: [], data: [], colors: [] },
    },

    leaveDetailsData: {
      tableData: [],
      others: [],
    },
  },
  //separate dash_V2

  dashBoardAttenGetStaus: "idle",
  dashBoardAttenGetLoading: false,
  dashBoardAttenGetError: null,

  empAttachGetData: {},
  empAttachGetStaus: "idle",
  empAttachGetLoading: false,
  empAttachGetError: null,

  //SCOREBOARD
  ScoredashBoardGetData: {},
  ScoredashBoardGetStaus: "idle",
  ScoredashBoardGetLoading: false,
  ScoredashBoardGetError: null,


  AppraisaldashBoardGetData: {},
  AppraisaldashBoardGetStaus: "idle",
  AppraisaldashBoardGetLoading: false,
  AppraisaldashBoardGetError: null,

  empEffortGetData: [],
  empEffortGetLoading: false,

  sprintBurndownGetData: {
    xaxis: [],
    yaxis: [],
  },
  sprintBurndownGetLoading: false,
  sprintBurndownGetStatus: false,
};

export const dashBoardTask = createAsyncThunk(
  "dashBoardTask/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.dashBoardTaskUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const dashBoardAtten = createAsyncThunk(
  "dashBoardAtten/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.dashBoardV1url;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const dashBoard_V2 = createAsyncThunk(
  "dashBoard_V2/getdata",
  async ({ data }, thunkAPI) => {
    try {
      const url = thunkAPI.getState().globalurl.Dashboard_V2;

      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);
export const ScoredashBoard = createAsyncThunk(
  "ScoredashBoard/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.Scoreboard;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const AppraisalScoredashBoard = createAsyncThunk(
  "AppraisalScoredashBoard/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.AppraisalScoreBoardController;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const SprintBurnDown = createAsyncThunk(
  "SprintBurnDown/Dashboard",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.SprintBurnDownUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const EmployeeEffort = createAsyncThunk(
  "dashBoardAtten/EmployeeEffort",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.dashBoardV1urlEmployeeEffort;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const attachmentPost = createAsyncThunk(
  "attachmentPost/postdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.empAttachmentUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getApiSlice = createSlice({
  name: "loginApi",
  initialState,
  reducers: {
    pending(state) {
      return {
        ...state,
        loading: true,
        error: false,
      };
    },
    errored(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    Success(state, action) {
      console.log(
        "stage6--LoginReducer--inside Sucess reducer data" +
        JSON.stringify(action.payload)
      );

      return {
        ...state,
        loading: false,
        error: "",
        loginData: action.payload.apiResponse,
        Status: action.payload.Status,
        msg: action.payload.Msg,
      };
    },

    resetData: (state, action) => {
      state.dashBoardAttenGetData = {
        taskSummaryCardData: [],
        taskWeekMonthData: {
          weekData: [],
          monthData: [],
          xaxis: [],
          yaxis: [],
        },
        projectTaskData: {
          xaxis: [],
          yaxis: [],
          leaveDetailsData: {
            tableData: [],
          },
          CumulativeChart: {
            xaxis: [],
            yaxis: [],
          },
        },
        leaveDetailsData: {
          tableData: [],
          others: [],
          currentMonth: [],
          nextMonth: [],
          currentYear: [],
        },
        agingData: {
          backlogData: [],
          todoData: [],
          completedData: [],
        },
        attendanceOverViewData: {
          laybels: [],
          Yearlysereies: [],
          Monthlysereies: [],
        },
        CumulativeChart: {
          xaxis: [],
          yaxis: [],
        },
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(SprintBurnDown.pending, (state, action) => {
        state.sprintBurndownGetData = {
          xaxis: [],
          yaxis: [],
        };
        state.sprintBurndownGetStatus = "pending";
        state.sprintBurndownGetLoading = true;
      })
      .addCase(SprintBurnDown.fulfilled, (state, action) => {
        state.sprintBurndownGetData = action.payload;
        state.sprintBurndownGetStatus = "fulfilled";
        state.sprintBurndownGetLoading = false;
      })
      .addCase(SprintBurnDown.rejected, (state, action) => {
        state.sprintBurndownGetStatus = "rejected";
        state.sprintBurndownGetLoading = false;
      })
      .addCase(dashBoardTask.pending, (state, action) => {
        state.dashBoardTaskGetData = [];
        state.dashBoardTaskGetStaus = "pending";
        state.dashBoardTaskGetLoading = true;
        state.dashBoardTaskGetError = null;
      })
      .addCase(dashBoardTask.fulfilled, (state, action) => {
        state.dashBoardTaskGetData = action.payload.Data;
        state.dashBoardTaskGetStaus = "fulfilled";
        state.dashBoardTaskGetLoading = false;
        state.dashBoardTaskGetError = null;
      })
      .addCase(dashBoardTask.rejected, (state, action) => {
        state.dashBoardTaskGetData = [];
        state.dashBoardTaskGetStaus = "rejected";
        state.dashBoardTaskGetLoading = false;
        state.dashBoardTaskGetError = null;
      })

      .addCase(EmployeeEffort.pending, (state, action) => {
        state.empEffortGetData = [];
        state.empEffortGetLoading = true;
      })
      .addCase(EmployeeEffort.fulfilled, (state, action) => {
        state.empEffortGetData = action.payload.Data;
        state.empEffortGetLoading = false;
      })
      .addCase(EmployeeEffort.rejected, (state, action) => {
        state.empEffortGetData = [];
        state.empEffortGetLoading = false;
      })
      .addCase(dashBoardAtten.pending, (state, action) => {
        state.dashBoardAttenGetData = {
          taskSummaryCardData: [],
          taskWeekMonthData: {
            weekData: [],
            monthData: [],
          },
          projectTaskData: {
            xaxis: [],
            yaxis: [],
            leaveDetailsData: {
              tableData: [],
              CumulativeChart: {
                xaxis: [],
                yaxis: [],
              },
            },
          },
          leaveDetailsData: {
            tableData: [],
            others: [],
            currentMonth: [],
            nextMonth: [],
            currentYear: [],
          },
          agingData: {
            backlogData: [],
            todoData: [],
            completedData: [],
          },
          attendanceOverViewData: {
            laybels: [],
            Yearlysereies: [],
            Monthlysereies: [],
          },
          CumulativeChart: {
            xaxis: [],
            yaxis: [],
          },
        };
        state.dashBoardAttenGetStaus = "pending";
        state.dashBoardAttenGetLoading = true;
        state.dashBoardAttenGetError = null;
      })
      .addCase(dashBoardAtten.fulfilled, (state, action) => {
        state.dashBoardAttenGetData = action.payload;
        console.log("🚀 ~ .addCase ~ action.payload:", action.payload);
        state.dashBoardAttenGetStaus = "fulfilled";
        state.dashBoardAttenGetLoading = false;
        state.dashBoardAttenGetError = null;
      })
      .addCase(dashBoardAtten.rejected, (state, action) => {
        state.dashBoardAttenGetData = {
          taskSummaryCardData: [],
          taskWeekMonthData: {
            xaxis: [],
            yaxis: [],
            weekData: [],
            monthData: [],
          },
          projectTaskData: {
            xaxis: [],
            yaxis: [],
            leaveDetailsData: {
              tableData: [],
              CumulativeChart: {
                xaxis: [],
                yaxis: [],
              },
            },
          },
          leaveDetailsData: {
            tableData: [],
            others: [],
            currentMonth: [],
            nextMonth: [],
            currentYear: [],
          },
          agingData: {
            backlogData: [],
            todoData: [],
            completedData: [],
          },
          attendanceOverViewData: {
            laybels: [],
            Yearlysereies: [],
            Monthlysereies: [],
          },
        };
        state.dashBoardAttenGetStaus = "rejected";
        state.dashBoardAttenGetLoading = false;
        state.dashBoardAttenGetError = null;
      })
      //separate dash_V2
      // 🔄 PENDING
      .addCase(dashBoard_V2.pending, (state) => {
        state.dashboardDataV2 = {
          taskSummaryCardData: [],
          taskTimeline: {
            w2d: [],
            m2d: [],
          },
          tasks: {
            w2d: {
              backlog: [],
              todo: [],
              inprogress: [],
              completed: [],
              approved: [],
            },
            m2d: {
              backlog: [],
              todo: [],
              inprogress: [],
              completed: [],
              approved: [],
            },
          },
          projectStats: [],
          projectTaskData: {
            xaxis: [],
            Projects: [],
            yaxis: [],
          },
          taskAging: {
            backlog: { labels: [], data: [], colors: [] },
            todo: { labels: [], data: [], colors: [] },
            completed: { labels: [], data: [], colors: [] },
          },
          attendance: {
            Y2D: { labels: [], data: [], colors: [] },
            W2D: { labels: [], data: [], colors: [] },
          },
          leaveDetailsData: {
            tableData: [],
            others: [],
          },
        };

        state.loadingV2 = true;
        state.errorV2 = null;
      })

      // ✅ FULFILLED
      .addCase(dashBoard_V2.fulfilled, (state, action) => {
        const res = action.payload;

        console.log("🚀 Dashboard V2:", res);

        if (res?.status) {
          state.dashboardDataV2 = res.data;
          state.loadingV2 = false;
          state.errorV2 = null;
        } else {
          state.loadingV2 = false;
          state.errorV2 = res?.message || "Something went wrong";
        }
      })

      // ❌ REJECTED
      .addCase(dashBoard_V2.rejected, (state, action) => {
        state.dashboardDataV2 = {
          taskSummaryCardData: [],
          taskTimeline: {
            w2d: [],
            m2d: [],
          },
          tasks: {
            w2d: {
              backlog: [],
              todo: [],
              inprogress: [],
              completed: [],
              approved: [],
            },
            m2d: {
              backlog: [],
              todo: [],
              inprogress: [],
              completed: [],
              approved: [],
            },
          },
          projectStats: [],
          projectTaskData: {
            xaxis: [],
            Projects: [],
            yaxis: [],
          },
          taskAging: {
            backlog: { labels: [], data: [], colors: [] },
            todo: { labels: [], data: [], colors: [] },
            completed: { labels: [], data: [], colors: [] },
          },
          attendance: {
            Y2D: { labels: [], data: [], colors: [] },
            W2D: { labels: [], data: [], colors: [] },
          },
          leaveDetailsData: {
            tableData: [],
            others: [],
          },
        };

        state.loadingV2 = false;
        state.errorV2 =
          action.payload || action.error?.message || "API Failed";
      })
      //separate dash_V2
      //SCOREBOARD
      .addCase(ScoredashBoard.pending, (state, action) => {
        state.ScoredashBoardGetData = []
        // state.dashBoardAttenGetData = {
        //   // taskSummaryCardData: [],

        //   ScoreChart: {
        //     xaxis: [],
        //     yaxis: [],
        //   },
        // };
        state.ScoredashBoardGetStaus = "pending";
        state.ScoredashBoardGetLoading = true;
        state.ScoredashBoardGetError = null;
      })

      .addCase(ScoredashBoard.fulfilled, (state, action) => {
        state.ScoredashBoardGetData = action.payload;
        console.log("🚀 ~ .addCase ~ action.payload:", action.payload);
        state.ScoredashBoardGetStaus = "fulfilled";
        state.ScoredashBoardGetLoading = false;
        state.ScoredashBoardGetError = null;
      })
      .addCase(ScoredashBoard.rejected, (state, action) => {
        state.ScoredashBoardGetData = [];
        state.ScoredashBoardGetStaus = "rejected";
        state.ScoredashBoardGetLoading = false;
        state.ScoredashBoardGetError = null;
      })

      //APPRAISAL SCORE BOARD
      .addCase(AppraisalScoredashBoard.pending, (state, action) => {
        state.AppraisaldashBoardGetData = {}
        state.AppraisaldashBoardGetStaus = "pending";
        state.AppraisaldashBoardGetLoading = true;
        state.AppraisaldashBoardGetError = null;
      })

      .addCase(AppraisalScoredashBoard.fulfilled, (state, action) => {
        state.AppraisaldashBoardGetData = action.payload;
        console.log("🚀 ~ .addCase ~ action.payload:", action.payload);
        state.AppraisaldashBoardGetStaus = "fulfilled";
        state.AppraisaldashBoardGetLoading = false;
        state.AppraisaldashBoardGetError = null;
      })
      .addCase(AppraisalScoredashBoard.rejected, (state, action) => {
        state.AppraisaldashBoardGetData = {};
        state.AppraisaldashBoardGetStaus = "rejected";
        state.AppraisaldashBoardGetLoading = false;
        state.AppraisaldashBoardGetError = null;
      });
  },
});

// Destructure and export the plain action creators
export const { pending, errored, resetData, Success } = getApiSlice.actions;

export default getApiSlice.reducer;

export function fetchApidata(
  emailID,
  password,
  license,
  usercode,
  company,
  year
) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + JSON.stringify(success.data));
      localStorage.setItem("loginUserData", JSON.stringify(success.data.Data));
      const datawait = dispatch(
        Success({
          Status: success.data.Status,
          apiResponse: success.data.Data,
          EmpCount: success.data.EmpCount,
          MangerEmpID: success.data.MangerEmpID,
          LoginType: success.data.LoginType,
          Msg: success.data.Msg,
          ScrumMaster: success.data.ScrumMaster,
          Classification: success.data.Classification,
          CompanyAutoCode: success.data.CompanyAutoCode,
          Module: success.data.Module,
          ProjectManager: success.data.ProjectManager,
          MultipleChildren: success.data.MultipleChildren,
          EmpMailID: success.data.EmpMailID,
          EmpMobileNo: success.data.EmpMobileNo,
          ParentID: success.data.ParentID,
          FirstLevelSub: success.data.FirstLevelSubpanitantes,
          MangerEmpDetails: success.data.MangerEmpDetails,
          ClassificationData: success.data.ClassificationData,
          CompanyLogo: success.data.CompanyLogo,
          CompanyHeader: success.data.CompanyHeader,
          CompanyQRCode: success.data.CompanyQRCode,
          CompanyFooter: success.data.CompanyFooter,
          CompanySignature: success.data.CompanySignature,
          InvoiceFlag: success.data.InvoiceFlag,
          SubscriptionCode: success.data.SubscriptionCode,
          CompanySessionTimeOut: success.data.CompanySessionTimeOut,
          CompanyGraceTime: success.data.CompanyGraceTime
        })
      );
      return datawait;
    }
    function onError(error) {
      const errorMsg = error.response.data.Msg;
      dispatch(errored(errorMsg));
      toast.error(errorMsg);
      return errorMsg;
    }
    try {
      var url = store.getState().globalurl.loginUrl;
      var idata = {
        Query: {
          //Name: emailID,
          Code: emailID,
          Password: password,
          LicenseKey: license,
        },
      };
      dispatch(pending());
      idata = JSON.stringify(idata);
      // console.log("🚀 ~ file: LoginReducer.js:94 ~ r eturn ~ idata:", idata)
      const success = await axios.get(url, {
        params: {
          data: idata,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export const ForgotPasswordRequest = async (requestData) => {
  const url = store.getState().globalurl.forgotUrl; // URL from the store
  try {
    const response = await axios.post(url, requestData, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data; // Return the API response data
  } catch (error) {
    console.error("Error in ForgotPasswordRequest:", error);
    throw error;
  }
};
export const ChangePasswordRequest = async (requestData) => {
  const url = store.getState().globalurl.ChangepasswordUrl; // URL from the store
  try {
    const response = await axios.post(url, requestData, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data; // Return the API response data
  } catch (error) {
    console.error("Error in ForgotPasswordRequest:", error);
    throw error;
  }
};
export const logout = createAction("loginApi/logout");
